import { httpClient } from "../../../shared/api/httpClient"
import { limpiarCacheSesion } from "../../../shared/api/cacheSesion"
import type {
    CompaniaCrearRequest,
    CompaniaCrearResult,
    CompaniasBuscarRequest,
    CompaniasBuscarResult,
    CompaniaDeleteRequest,
    CompaniaDeleteResult,
    CompaniaMostrarRequest,
    CompaniaMostrarResult,
    CompaniaEditarRequest,
    CompaniaEditarResult,
} from "../types/companias.types"

export const companiaCrear = async (dataPOST: CompaniaCrearRequest): Promise<CompaniaCrearResult | undefined> => {
    try {

        const res = await httpClient.post("api/compania/AgregarCompania", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            limpiarCacheSesion() // catálogos cambiaron (compañía/sucursal): invalidar cache
            return {
                status: res.data.status,
                compania: res.data.compania,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                compania: "",
                message: error.response.data.message,
            };
        }
        return {
            status: -1,
            compania: "",
            message: "Error en el servidor",
        }
    }
}

export const companiasBuscar = async (dataPOST: CompaniasBuscarRequest): Promise<CompaniasBuscarResult | undefined> => {
    try {

        const res = await httpClient.post("api/compania/BuscarCompania", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                companias: res.data.resultado,
                message: res.data.message
            }
        }

    } catch (error) {
        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                companias: [],
                message: error.response.data.message,
            };
        }
        return {
            status: -1,
            companias: [],
            message: "Error en el servidor",
        }
    }
}

export const companiaDelete = async (dataPOST: CompaniaDeleteRequest): Promise<CompaniaDeleteResult | undefined> => {
    try {

        const res = await httpClient.post("api/compania/EliminarCompania", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            limpiarCacheSesion() // catálogos cambiaron (compañía/sucursal): invalidar cache
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}

export const companiaMostrar = async (dataPOST: CompaniaMostrarRequest): Promise<CompaniaMostrarResult | undefined> => {
    try {

        const res = await httpClient.post("api/compania/MostrarCompania", dataPOST)

        // res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                compania: res.data.resultado,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                compania: {},
                message: error.response.data.message,
            };
        }
        return {
            status: -1,
            compania: {},
            message: "Error en el servidor",
        }
    }
}

export const companiaEditar = async (dataPOST: CompaniaEditarRequest): Promise<CompaniaEditarResult | undefined> => {
    try {

        const res = await httpClient.post("api/compania/ActualizarCompania", dataPOST)

        //res.status 201
        if (res.data.status === 1) {
            limpiarCacheSesion() // catálogos cambiaron (compañía/sucursal): invalidar cache
            return {
                status: res.data.status,
                message: res.data.message,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
        }
    }
}
